module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAmUlEQVR4AeyR0Q2AIAxExUl0E0d3E9kE7whpaFKDCH4YMZwphdzT6zy9/PwIEEJYoCNpuZtsTUQbTGlMsca2vGoAZTfjxncAmI05o55/wLlwPhTrGJgArr4g3mp4CQAepJJOsUarfeWAdjfDYQCMUHRrRKTzMHZ5RDvOfRJrlGqxV30uAOech9YkGil39B+dC0C5ddwMQDHMEwAA//8ty/xUAAAABklEQVQDAKlvPDHnp8g5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/renshu@2x.png
// module id = 312
// module chunks = 1